module.exports = __webpack_public_path__ + "img/coupon-unstart.452b6a6d.png";